export const extractAddressComponents = (place) => {
  const address = {
    line1: "",
    line2: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
  };

  if (!place || !place.address_components) return address;

  place.address_components.forEach((component) => {
    if (component.types.includes("street_number")) {
      address.line1 = component.long_name;
    }
    if (component.types.includes("route")) {
      address.line1 += ` ${component.long_name}`;
    }
    if (component.types.includes("locality")) {
      address.city = component.long_name;
    }
    if (component.types.includes("postal_code")) {
      address.postal_code = component.long_name;
    }
    if (component.types.includes("administrative_area_level_1")) {
      address.state = component.short_name;
    }
    if (component.types.includes("country")) {
      address.country = component.short_name;
    }
  });

  return address;
};
